import React, {useEffect, useMemo, useState} from "react";
import avatarDefault from "../../../images/avatardefault.png";
import {Spinner} from "../index";
import {useIntl} from "react-intl";
import {getCachedImageUrl, getLocalDateString, getLocalDateTimeString} from "../../../utils/utils";
import {Link} from "react-router-dom";
import auth from "../../../utils/authentication";

import './user-post.scss';
import {SquadDiskUsersApi} from "../../../apis/squaddisk-users/SquadDiskUsersApi";

type Props = {
    uid?: string;
    user?: any;
    className?: string;
    children: React.ReactNode;
    options?: React.ReactNode;
    postDate?: string | Date;
    loading?: boolean;
    includeTime?: boolean;
}

function UserPost({
                      uid,
                      user: initialUser,
                      className,
                      loading,
                      children,
                      postDate,
                      options,
                      includeTime
                  }: Props) {

    const intl = useIntl();

    const [user, setUser] = useState(initialUser);

    useEffect(() => {
        if (initialUser?.displayName) {
            setUser(initialUser);
            return;
        }
        SquadDiskUsersApi.getUserInfoByUid({uid}).then(res => {
            setUser(res.data)
        });
    }, [initialUser, uid]);

    const linkUser = useMemo(() => {
        if (!user?.uid) {
            return '';
        }
        const isAuthedUser = auth.currentUser.uid === user?.uid;
        if (isAuthedUser) {
            return `/my-profile/posts`;
        } else {
            return `/user/${user.displayName}/${user.userCode}/posts`;
        }
    }, [user])

    if (!user?.uid || !user?.userCode || loading) {
        return (
            <div>
                <Spinner className="spinner-sm"/>
            </div>
        )
    }
    // Use user-card-details to fast info without navigating
    return (
        <div className="user-post">
            <Link to={linkUser}>
                <img className="user-post__img" alt={user.displayName}
                     src={user.photoURL ? getCachedImageUrl(user.photoURL) : avatarDefault}/>
            </Link>
            <div className="d-flex flex-column" style={{width: "100%"}}>
                <div>
                    <div className="">
                        <Link to={linkUser} style={{textDecoration: 'none'}}
                              className={"text-body-emphasis fs-5 " + className}>
                            {user.displayName}
                            <span className="ms-2 text-muted" style={{
                                fontSize: "small",
                                fontWeight: "lighter"
                            }}>#{user.userCode}</span>
                        </Link>
                        <span className="mx-2 text-muted">
                        ·
                        </span>
                        <span className="text-muted" style={{
                            fontSize: "small",
                            fontWeight: "lighter"
                        }}>
                            {includeTime ? getLocalDateTimeString(postDate) : getLocalDateString(postDate)}
                        </span>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default UserPost;
